/* eslint-disable react/jsx-props-no-spreading */
import { ReactElement, Suspense, lazy } from "react";
import { AWSCloudWatchProvider, Amplify, Logger, Storage } from "aws-amplify";
import awsconfig from "./aws-exports";
import { Route, Routes } from "react-router-dom";
import { noauthRoutes, routes } from "routes";
import { PrivateRoutes, UnLoggedRoutes } from "routes/private-routes";
import CustomProvider from "hook/context";
import Spinner from "components/spinner";
import PageNotFound from "pages/page-not-found";
import MainLayout from "components/main-layout";
import NoAuthLayout from "components/noauth-layout";
import { ROUTERS } from "constants/routes.constant";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

Amplify.configure(awsconfig);
Storage.configure({
  customPrefix: {
    public: "",
    protected: "protected/",
    private: "private/",
  },
});
const logger = new Logger("SUMMIT_HSHC", "DEBUG");
Amplify.register(logger);
logger.addPluggable(
  new AWSCloudWatchProvider({
    logGroupName: "FRONTEND",
    logStreamName: process.env.ENV ?? "production",
    region: awsconfig.aws_project_region,
  }),
);

// const Approve = lazy(() => import("./pages/approve"));
const Service = lazy(() => import("./pages/service-list"));
const UserRegisterVendor = lazy(() => import("./pages/user-register-vendor"));

const App = (): ReactElement => {
  return (
    <CustomProvider>
      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path="/" element={<MainLayout />}>
            <Route
              index
              element={
                <Suspense fallback={<Spinner />}>
                  <Service />
                </Suspense>
              }
            />
            {routes.map(({ path, component, ...rest }, index) => (
              <Route
                key={`route_${index}`}
                path={path}
                element={
                  <Suspense fallback={<Spinner />}>{component}</Suspense>
                }
                {...rest}
              />
            ))}
          </Route>
        </Route>
        <Route element={<UnLoggedRoutes />}>
          <Route path="/" element={<NoAuthLayout />}>
            {noauthRoutes.map(({ path, component, ...rest }, index) => (
              <Route
                key={`noauth_route_${index}`}
                path={path}
                element={
                  <Suspense fallback={<Spinner isFullWidth={true} />}>
                    {component}
                  </Suspense>
                }
                {...rest}
              />
            ))}
          </Route>
        </Route>
        <Route
          path={ROUTERS.USER_REGISTER_VENDOR}
          element={<UserRegisterVendor />}
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </CustomProvider>
  );
};

export default App;
export { logger };
